// @flow

import type { Query } from '~schema';

export default function getPreviewData(): ?Query {
  return typeof window === 'undefined'
    ? undefined
    : window.__PRISMIC_PREVIEW_DATA__;
}
